// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"toolbar_toolbar__318X5"};